<template>
  <div class="landing">
    <div :class="{ loading: true, 'animate-start': loaded, 'animate-end': animateEnd }"></div>
    <template v-if="loaded">
    <video class="video" autoplay loop muted>
      <source src="../assets/beast.mp4" type="video/mp4">
      Your browser does not support the video tag.
    </video>

    <div class="content">

    <!--<div class="countdown-clock">{{ countdown }}</div>-->
    <div class="free-spots">
      Sunday June 28th, 9am
    </div>
    <div class="message">
        <!--
        <h2 v-if="open"> Only <em><strong>{{ spots }}</strong></em> spot<span v-if="spots > 1">s</span> left!</h2>
        <div v-if="!open" class="reg-closed">
          Registration is now closed! Get on the <a href="#/register">waitlist</a> to reserve a spot.
        </div>
        -->
    </div>

    <div class="banner">
      <h1>The Bonnington Beast</h1>
      <h2>Run/Walk/Crawl</h2>
    </div>

    <div class="badges">
      <div class="badge">
        <img src="../assets/icons/distance-ico.png"/>
        <h2>3.8km</h2>
        <p>Total Distance</p>
      </div>
      <div class="badge">
        <img src="../assets/icons/elevation-ico.png"/>
        <h2>700ft</h2>
        <p>Elevation</p>
      </div>

    </div>
   </div>
   </template>
  </div>
</template>

<script>
import moment from 'moment';
import { db } from '../../environment.ts';

export default {
  name: 'Landing',
  data: function() {
    return {
      fading: false,
      loaded: false,
      open: true,
      spots: 0,
      maxTeams: 10,
      animateEnd: false,
      countdown: this.getCountdown(),
    }
  },
  firestore() {
    return {
      participants: db.collection('participants'),
      waitlist: db.collection('waitlist')
    }
  },
  mounted() {
    this.$firestore.participants.onSnapshot((snap) => {
      this.spots = this.maxTeams - snap.size;
      this.open = this.spots > 0;
      this.loaded = true;
      setTimeout(() => {
        this.animateEnd = true;
      }, 1000)
    })
    setInterval(() => {
      this.countdown = this.getCountdown();
    }, 1000)
  },
  methods: {
    getCountdown: function () {
      const current = moment(new Date());
      const raceDate = moment(new Date(2020, 5, 28, 9, 0, 0));
      const duration = raceDate.diff(current, 'seconds');

      return duration;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.loading {
  position: fixed;
  height: 100vh;
  width: 100vw;
  background: black;
  transition: opacity 1s ease-in-out;
  z-index: 100;
}

.animate-start {
  opacity: 0;
}

.animate-end {
  display: none;
}

.loaded {
  display: none;
}

.message {
  min-height: 33px;
}

.video {
  position: absolute;
  top: 20px;
  left: 0;
  width: 100%;
  z-index: 0;
}

.content {
  background: rgba(0,0,0,0.5);
  color: white;
  padding-top: 60px;
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 1;
  min-height: calc(100% - 60px)
}

.banner p {
  font-size: 18px;
}

.landing {
  height: 100%;
}

.landing h1 {
  margin-top: 0;
  font-size: 3em;
  margin-bottom: 10px;
}

.landing h2 {
  margin-top: 0;
  font-weight: 200;
  margin-bottom: 0;
}

.landing h3 {
  margin-top: 0;
  font-weight: 200;
}

@media only screen and (max-width: 600px) {
  .countdown-clock {
    font-size: 3em;
  }
  .landing h1 {
    font-size: 2em;
  }
}

@media only screen and (min-width: 600px) {
  .countdown-clock {
    font-size: 7em;
  }
  .landing h1 {
    font-size: 3.5em;
  }
}

.free-spots {
  font-size: 2em;
}
.reg-closed {
  font-size: 1.5em;
}

.beast-eye {
  width: 100px;
}

.beast-eye.reversed {
  transform: scaleX(-1)
}

.beast-eyes {
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 380px;
  justify-content: space-between;
}

.beast-mouth {
  width: 100%;
  max-width: 600px;
}

.landing-imgs {
  margin-top: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.banner {
  padding: 20px;
  margin-top: 40px;
}

.badges {
  display: flex;
  justify-content: center;
  align-items: center;
}

.badge {
  margin: 20px;
}

.badge h2 {
  font-size: 3em;
  margin: 0
}

.badge p {
  margin: 0;
}

.badge img {
  width: 80px;
}
</style>
